import { AuthActions } from "@infobis/as-react-auth";

import MapSettingAction from "./map/action-creators"
import { actions as WeatherActions } from "./weather"
import { actions as ApplicationSettings } from "./settings"
import { actions as MapTabActions } from "./map/settings/mapTab"
import { actions as GeoZoneTabActions } from "./map/settings/geoZonesTab"
import { actions as MarkersTabActions } from "./map/settings/markersTab"
import { actions as CropSelectorActions } from "./dashboard/crops/selector"
import { actions as PhasesDashboardActions } from "./dashboard/phases"
import { actions as NDVIDashboardActions } from "./dashboard/ndvi"
import { actions as CropsConditionsActions } from "./dashboard/cropscondition"
import { actions as WorkDetalizationActions } from "./dashboard/works/detalization"
import { actions as CropDetalizationActions } from "./dashboard/crops/detalization"
import { actions as ExpenseDetalizationActions } from "./dashboard/expenses/detalization"
import { actions as DashExpensesAction } from "./dashboard/expenses"
import { actions as ReferenceOperationActions } from "./references/operations"
import { actions as PartnersGoodsActions } from "./partners/goods/index"
import { actions as DashCropsAction } from "./dashboard/crops/";
import { actions as DashWorksAction } from "./dashboard/works/";
import { actions as ReferenceOrganizationActions } from "./references/organizations"
import { actions as UsersSliceActions } from './partners/users';
// import UnitsAction from "./units/action-creators"
// import FieldsAction from "./fields/action-creators"
import { actions as EfficiencyActions } from './dashboard/works/efficiency';
import { actions as IdlesActions } from './dashboard/works/idles';
import { actions as WorksByDepartmentsAndCropsActions } from './dashboard/works/byDepartmentsAndCrops';
import { actions as SelectedDateActions } from './dashboard/date';
import { actions as VehiclesStatusesActions } from './dashboard/vehicles/statuses';
import { actions as VehiclesTypesActions } from './dashboard/vehicles/types';

export const allActionCreators = {
    ...AuthActions,
    ...ReferenceOperationActions,
    ...DashExpensesAction,
    ...DashCropsAction,
    ...DashWorksAction,
    ...CropsConditionsActions,
    ...NDVIDashboardActions,
    ...MapSettingAction,
    ...MapTabActions,
    ...GeoZoneTabActions,
    ...MarkersTabActions,
    ...CropSelectorActions,
    ...PhasesDashboardActions,
    ...CropDetalizationActions,
    ...WorkDetalizationActions,
    ...WeatherActions,
    ...ReferenceOrganizationActions,
    ...WeatherActions,
    ...ExpenseDetalizationActions,
    ...WeatherActions,
    ...ApplicationSettings,
    ...PartnersGoodsActions,
    ...UsersSliceActions,
    ...EfficiencyActions,
    ...IdlesActions,
    ...WorksByDepartmentsAndCropsActions,
    ...SelectedDateActions,
    ...VehiclesStatusesActions,
    ...VehiclesTypesActions
}

export type ActionsType = typeof allActionCreators

// в этом файле собираются все action creators и экспортируются объектом.